import "./per-view-container.styles.scss";

const PerViewContainer = ({ children }) => {
  return <div className="per-view-container index-container">{children}</div>;
};

export default PerViewContainer;
